const features = [
  {
    icon: 'ri-user-smile-line',
    title: 'Facile da utilizzare',
    description: 'Interfaccia semplice e intuitiva, perfetta anche per chi non ha esperienza con strumenti di gestione dati.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Maggiore produttivit\u00e0',
    description: 'Riduci le attivit\u00e0 ripetitive e automatizza i processi per concentrarti su ci\u00f2 che conta davvero.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Organizzazione intelligente',
    description: 'Gestisci le tue informazioni in modo efficace con un sistema strutturato e personalizzabile.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sicurezza',
    description: 'Segui le pratiche corrette per proteggere i tuoi dati e mantenere le informazioni al sicuro.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Perch&eacute; scegliere <strong>Itaobuy Spreadsheet</strong>?
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Ecco i principali vantaggi che rendono <strong>Itaobuy Spreadsheet</strong> la scelta ideale per la gestione dei tuoi dati.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div key={feature.title} className="group bg-background-50 border border-background-200 rounded-2xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}